// 通过球队全称筛选球队简称
export function filterSquadName (val) {
  if (!val) return ''
  let sex = val.indexOf('男') < 0 ? '女足' : '男足'
  if (val.indexOf('U') < 0) {
    return sex + '国家队'
  } else {
    if (val.indexOf('22') < 0) {
      return sex + val.substr(2, 4)
    } else {
      return sex + val.substr(2, 4) + '(国奥队)'
    }
  }
}

// code码，返回相应的汉字提示
export function filterCode (val) {
  let tip = ''
  switch (val) {
    case 'SquadNameBusy': tip = '该球队名称已被占用'
      break
    case 'MasterCoachBusy': tip = '该主教练已存在其他球队'
      break
    case 'LeaderBusy': tip = '该领队已存在其他球队'
      break
    case 'CoachBusy': tip = '教练数据更新，请刷新页面后重试'
      break
    case 'LoginNameRepeat': tip = '该用户名已经被注册'
      break
    case 'phoneIsExist':
    case 'PhoneRepeat': tip = '该手机号已经被注册'
      break
    case 'EmailRepeat': tip = '该邮箱已经被注册'
      break
    case 'UserAddFail': tip = '该用户不存在'
      break
    case 'IdNumberRepeat': tip = '该身份证号已经被注册'
      break
    case 'LeaderAddRepeat': tip = '该领队已被注册，请勿重复添加'
      break
    case 'PlayerUserExistent': tip = '该球员已被注册'
      break
    case 'PlayerNoExist': tip = '球员不存在'
      break
    case 'LeaderInexistence': tip = '领队不存在'
      break
    case 'CoachInexistence': tip = '教练不存在'
      break
    case 'TeachingUuidInexistence': tip = '教案不存在'
      break
    case 'UsernameCanNotBeEmpty': tip = '用户名不能为空'
      break
    case 'PasswordCanNotBeEmpty': tip = '密码不能为空'
      break
    case 'UserDisabled': tip = '账户已禁用，请联系客服咨询'
      break
    case 'UsernameOrPasswordError': tip = '用户名或密码错误'
      break
    case 'LoginBindingSquad': tip = '该帐号未绑定球队，请联系客服'
      break
    case 'UserUuidInexistence': tip = '信息异常'
      break
    case 'TrainingPlanInexistence': tip = '训练计划不存在'
      break
    case 'oldPasswordError': tip = '原密码错误'
      break
    case 'verifyCodeIsError': tip = '验证码错误'
      break
    case 'PlayerHaveTraining': tip = '该球员存在训练计划不能删除'
      break
    case 'UserRole error':
    case 'User not exist': tip = '用户名不存在'
      break
    case 'Account not activated': tip = '该帐号未激活'
      break
    case 'Account disabled': tip = '该帐号被禁用,请联系客服'
      break
    default: tip = '参数错误，请联系客服'
      break
  }
  return tip
}

export function filterUserStatus (val) {
  let status = ''
  switch (val) {
    case 'EFFECTIVE': status = '正常'
      break
    case 'DISABLED': status = '关闭'
      break
    default: status = '--'
      break
  }
  return status
}

// 根据身份证返回年龄，性别，生日
export function filterIdNumber (val, idx) {
  if (!val) return false
  if (val.length !== 18) {
    return '--'
  }
  if (!idx) {
    return val.substring(6, 10) + '-' + val.substring(10, 12) + '-' + val.substring(12, 14)
  }
  if (idx === 1) {
    if (parseInt(val.substr(16, 1)) % 2 === 1) {
      return '男'
    } else {
      return '女'
    }
  }
  if (idx === 2) {
    var myDate = new Date()
    var month = myDate.getMonth() + 1
    var day = myDate.getDate()
    var age = myDate.getFullYear() - val.substring(6, 10) - 1
    if (val.substring(10, 12) < month || (val.substring(10, 12) === month && val.substring(12, 14) <= day)) {
      age++
    }
    return age
  }
}

// 根据身份证年返回年龄
export function getAgeFromIdNumberYear(val) {
  var myDate = new Date()
  var age = myDate.getFullYear() - val.substring(6, 10)
  return age
}

export function time (time, hasTime) {
  if (!time) {
    // 根据胡总需求不要秒
    // return hasTime === true ? '0-0-0 00:00:00' : '0-0-0'
    return hasTime === true ? '0-0-0 00:00' : '0-0-0'
  }
  let newTime = new Date(time)
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1
  let forMatMonth = String(month).length === 1 ? `0${month}` : month
  let day = new Date(time).getDate()
  let forMatDay = String(day).length === 1 ? `0${day}` : day
  let hour = newTime.getHours() > 9 ? newTime.getHours() : '0' + newTime.getHours()
  let minute = newTime.getMinutes() > 9 ? newTime.getMinutes() : '0' + newTime.getMinutes()
  let second = newTime.getSeconds() > 9 ? newTime.getSeconds() : '0' + newTime.getSeconds()
  // let dateString = newTime.toLocaleDateString().replace(/\//g, '-')
  let dateString = year + '-' + forMatMonth + '-' + forMatDay
  // 根据胡总需求不要秒
  // return hasTime === true ? dateString + ' ' + hour + ':' + minute + ':' + second : dateString
  return hasTime === true ? dateString + ' ' + hour + ':' + minute : dateString
}

export function timeMonth (time) {
  if (!time) {
    // 根据胡总需求不要秒
    // return hasTime === true ? '0-0-0 00:00:00' : '0-0-0'
    return '0-0'
  }
  let newTime = new Date(time)
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1
  let forMatMonth = String(month).length === 1 ? `0${month}` : month

  let dateString = year + '-' + forMatMonth
  // 根据胡总需求不要秒
  // return hasTime === true ? dateString + ' ' + hour + ':' + minute + ':' + second : dateString
  return dateString
}

export function timeYear (time) {
  if (!time) {
    // 根据胡总需求不要秒
    // return hasTime === true ? '0-0-0 00:00:00' : '0-0-0'
    return '----'
  }
  let newTime = new Date(time)
  let year = new Date(time).getFullYear()


  let dateString = year
  // 根据胡总需求不要秒
  // return hasTime === true ? dateString + ' ' + hour + ':' + minute + ':' + second : dateString
  return dateString
}

export function formatDateStamp(timestamp) {
  if (!timestamp) return '--';
  const date = new Date(parseInt(timestamp));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}


export function timeYearAndMonth (ms, hasTime = true, hasDay = true) {
  if (Number(ms) < 0) {
    return "--";
  }
  if (!ms) {
    let str = "";
    hasTime
      ? str = "0-0-0-0 00:00"
      : (hasDay ? '0-0-0-0' : '0-0');
    return str;
  }
  // if(Number.isNaN(Date.parse(ms))) {
  //   return hasTime ? "0-0-0-0 00:00" : "0-0-0-0";
  // }
  const date = new Date(Number(ms));
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let hours = date.getHours();
  hours = hours < 10 ? ('0' + hours) : hours;
  let minutes = date.getMinutes();
  minutes = minutes < 10 ? ('0' + minutes) : minutes;
  let seconds = date.getSeconds();
  seconds = seconds < 10 ? ('0' + seconds) : seconds;
  const dAndT = y + "-" + m + "-" + d + " " + hours + ":" + minutes + ":" + seconds;
  const ymd = y + "-" + m + "-" + d;
  const yAndM = y + "-" + m;
  return hasTime ? dAndT : (hasDay ? ymd : yAndM);
}

export function flashCheck () {
  let hasFlash = false
  if (document.all) {
    // eslint-disable-next-line no-undef
    let swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
    if (swf) {
      hasFlash = true
    }
  } else {
    if (navigator.plugins && navigator.plugins.length > 0) {
      let swf = navigator.plugins['Shockwave Flash']
      if (swf) {
        hasFlash = true
      }
    }
  }
  return hasFlash
}

export function filterRole (val) {
  let role = ''
  switch (val) {
    case 'player': role = '球员'
      break
    case 'leader': role = '领队'
      break
    case 'coach': role = '教练'
      break
    case 'system': role = '技术支持'
      break
    case 'admin': role = '系统管理员'
      break
    case 'organ': role = '区级管理员'
      break
    case 'youth': role = '机构管理员'
      break
    case 'trainCamp': role = '精英集训队管理员'
      break
    case 'club': role = '精英机构/基地管理员'
      break
    case 'expert': role = '评估专家'
      break
    default: role = '--'
      break
  }
  return role
}

export function centerStatus (val) {
  let res = ''
  switch (val) {
    case 'EFFECTIVE' : res = '有效'; break
    // case 'NONACTICATED' : res = '未激活'; break
    case 'DISABLED' : res = '禁用'; break
  }
  return res
}

export function orgTypeStatus (val) {
  let res = ''
  switch (val) {
    case 'PROVINCE' : res = '省级'; break
    case 'NATIONAL' : res = '中国足协'; break
    case 'CITY' : res = '市级'; break
  }
  return res
}

export function positionStatus (val) {
  let res = ''
  switch (val) {
    case 0 : res = '其他'; break
    case 101 : res = '守门员'; break
    case 102 : res = '后卫'; break
    case 103 : res = '中场'; break
    case 104 : res = '前锋'; break
    case 105 : res = '防守型边后卫'; break
    case 106 : res = '中后卫'; break
    case 107 : res = '进攻型边后卫'; break
    case 108 : res = '中锋'; break
    case 109 : res = '边锋'; break
    case 110 : res = '场上核心'; break
  }
  return res
}
export function competitionStatus (val) {
  let res = ''
  switch (val) {
    case 'goal' : res = '进球'; break
    case 'own_goal' : res = '乌龙球'; break
    case 'substitute' : res = '替换上场'; break
    case 'substituted': res = '替换下场'; break
    case 'yellow_card': res = '黄牌'; break
    case 'red_card': res = '红牌'; break
    case 'injury': res = '受伤'; break
    case 'corner': res = '角球'; break
    case 'free_kick': res = '任意球'; break
    case 'penalty': res = '点球'; break
    case 'shot_on_goal': res = '射正球门'; break
    case 'start_play': res = '比赛开始'; break
    case 'stop_play': res = '比赛结束'; break
    case 'line_up': res = '首发阵容'; break
  }
  return res
}

export function shareStatus (val) {
  let res = ''
  switch (val) {
    case 'Club' : res = '內部公开'; break
    // case 'NONACTICATED' : res = '未激活'; break
    case 'Private' : res = '个人私有'; break
    case 'Public' : res = '完全公开'; break
  }
  return res
}

export function testRegionFilter (val) {
  let res = ''
  switch (val) {
    case 'plateau' : res = '高原'; break
    case 'subPlateau' : res = '亚高原'; break
    case 'plain' : res = '平原'; break
  }
  return res
}

export function squadPlayerSex (val) {
  let res = ''
  switch (val) {
    case 'male' : res = '男足'; break
    case 'female' : res = '女足'; break
    case 'mixed' : res = '男女混合'; break
  }
  return res
}

export function uuid () {
  let s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = ''
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = ''

  return s.join('')
}


/* 工作类型过滤器 */
export function coachNatureFilters(val) {
  let res = '--';
  switch(val) {
    case 'full_time':
      res = '全职';
      break;
    case 'part_time':
      res = '兼职';
      break;
    default:
      break;
  }
  return res;
}

/* 数字 */
export function checkNumberValue(val) {
  if( typeof val == 'number') {
    return true
  } else {
    return false
  }
}

export function coachClassLevel (val) {
  let classLevel = '';
  switch (val) {
    case '0': classLevel = '职业级';
      break;
    case '1': classLevel = '其他';
      break;
    case 'A': classLevel = 'A级';
      break;
    case 'B': classLevel = 'B级';
      break;
    case 'C': classLevel = 'C级';
      break;
    case 'D': classLevel = 'D级';
      break;
    case 'E': classLevel = 'E级';
      break;
    case 'F1': classLevel = '体能L1级';
      break;
    case 'F2': classLevel = '体能L2级';
      break;
    case 'GC': classLevel = '守门员C级';
      break;
    case 'GB': classLevel = '守门员B级';
      break;
    case 'GA': classLevel = '守门员A级';
      break;
    default: classLevel = '--';
      break
  }
  return classLevel
}

export function trainCampEnrollStatus (val) {
  let res = ''
  switch (val) {
    case 'Edit' : res = '暂时保存'; break
    case 'Incomplete' : res = '报名进行中'; break
    case 'Finished' : res = '报名已结束'; break
    case 'Complete' : res = '报名已完成'; break
  }
  return res
}

export function trainCampEnrollType (val) {
  let res = ''
  switch (val) {
    case 'player' : res = '球员'; break
    case 'coach' : res = '教练'; break
    case 'scout' : res = '球探'; break
  }
  return res
}
